import React, { useState, } from 'react';
import { Table, Container, Input, Row, Col, Button } from 'reactstrap';
import "./Reports.css";
import { RiFileExcel2Line } from 'react-icons/ri'
import { AiOutlineFilePdf } from 'react-icons/ai'
import { useEffect } from 'react';

export function ConCludeBorrowComponent() {
    const [loading, setLoading] = useState(false);
    const [listFirstYear, setListFirstYear] = useState([]);
    const [firstYearSelected, setFirstYearSelected] = useState("0");
    const [listSecondYear, setListSecondYear] = useState([]);
    const [secondYearSelected, setSecondYearSelected] = useState("0");
    const [listBudgetYear, setListBudgetYear] = useState([]);
    const [conCludeBorrow, setConcludeBorrow] = useState(null);

    useEffect(() => {
        setListSecondYear(listFirstYear.filter((year => year >= firstYearSelected)));
    }, [firstYearSelected]);

    useEffect(() => {
        async function GetYearConcludeBorrow() {
            setLoading(true);
            try {
                let res = await fetch("/api/BorrowReports/getYearConcludeBorrow")
                let resJson = await res.json();
                setListFirstYear(resJson.dataenum);
            } catch (e) {
                // console.log("err", e);
            } finally {
                setLoading(false);
            }
        }
        GetYearConcludeBorrow();
    }, [])

    useEffect(() => {
        async function GetConcludeBorrow() {
            if (firstYearSelected === "0" || secondYearSelected === "0") {
                setConcludeBorrow(null);
            } else {
                try {
                    let res = await fetch("/api/BorrowReports/getConcludeBorrow", {
                        method: 'POST',
                        headers: { 'Content-type': 'application/json' },
                        body: JSON.stringify({
                            firstYearSelect: firstYearSelected,
                            secondYearSelect: secondYearSelected
                        })
                    })
                    let resJson = await res.json();
                    setListBudgetYear(resJson.dataenum.yearList.map(year => year + 543));
                    setConcludeBorrow(resJson.dataenum.concludeBorrow);
                } catch (e) {
                    // console.log(e);
                }
            }
        }
        GetConcludeBorrow();
    }, [firstYearSelected, secondYearSelected])



    if (loading) { return <>Loading....</> }
    return (
        <Container>

            <div className='d-flex justify-content-center align-items-center'>
                <span className='header-select-year mx-3'>ข้อมูลปีงบประมาณ</span>
                <Input
                    className="rounded-pill input-color w-25 text-center"
                    type="select"
                    value={firstYearSelected}
                    onChange={(e) => {
                        setFirstYearSelected(e.target.value)
                    }}
                >
                    <option defaultValue={"0"} value={"0"}>
                        กรุณาเลือก
                    </option>
                    {listFirstYear?.map(item => (
                        <option value={item.year} key={item.year}>
                            {Number(item.year)}
                        </option>
                    ))}

                </Input>
                <span className='header-select-year mx-3'>ถึง</span>
                <Input
                    className="rounded-pill input-color w-25 text-center"
                    type="select"
                    value={secondYearSelected}
                    onChange={(e) => {
                        setSecondYearSelected(e.target.value)
                    }}
                >
                    <option defaultValue={"0"} value={"0"}>
                        กรุณาเลือก
                    </option>
                    {listSecondYear?.map(item => (
                        <option value={item.year} key={item.year}>
                            {Number(item.year)}
                        </option>
                    ))}
                </Input>
            </div>

            <Row className='my-3'>
                <Col className='d-flex justify-content-end'>
                    <Button
                        disabled={firstYearSelected === "0" || secondYearSelected === "0" ? true : false}
                        className="btn border border-1 mx-1 btn-green"
                        href={`api/BorrowReports/exportConcludeBorrow?firstYearSelect=${firstYearSelected}&secondYearSelect=${secondYearSelected}&type=${1}`}
                        download
                    >
                        <RiFileExcel2Line />
                        Export Excel
                    </Button>
                    <Button
                        disabled={firstYearSelected === "0" || secondYearSelected === "0" ? true : false}
                        className="btn border border-1 mx-1 btn-red"
                        href={`api/BorrowReports/exportConcludeBorrow?firstYearSelect=${firstYearSelected}&secondYearSelect=${firstYearSelected}&type=${2}`}
                        download
                    >
                        <AiOutlineFilePdf />
                        Export PDF
                    </Button>
                </Col>
            </Row>

            <div className="report-wrapper-non-overflow">
                <Table className="styled-table text-center" bordered striped hover>
                    <thead className='styles-thead'>
                        <tr>
                            <th rowSpan="2" className='text-center'>
                                ลำดับ
                            </th>
                            <th rowSpan="2" className='text-center'>
                                รายการ
                            </th>
                            {listBudgetYear?.map(year => (
                                <th key={year} colSpan="2" className='text-center'>
                                    ปีงบประมาณ {year}
                                </th>
                            ))}
                        </tr>
                        {listBudgetYear?.map(year => (
                            <tr key={year}>
                                <th className='text-center'>
                                    จำนวนเงิน (บาท)
                                </th>
                                <th className='text-center'>
                                    จำนวน (บริษัท)
                                </th>
                            </tr>
                        ))}
                    </thead>
                    <tbody>
                        {conCludeBorrow?.length > 0 && conCludeBorrow !== null ? conCludeBorrow?.map((item, i) => (
                            <tr key={i}>
                                <td className='text-center'>
                                    {i + 1}
                                </td>
                                <td className='text-start'>
                                    {item?.columnName}
                                </td>
                                {item?.listDetailConcludeBorrow.map(data => (
                                    <>
                                        <td className='text-end'>
                                            {data.amount}
                                        </td>
                                        <td className='text-end'>
                                            {data.cnt}
                                        </td>
                                    </>
                                ))}

                            </tr>
                        )) : (
                            <tr>
                                <td colSpan="2" className='text-center'>
                                    ไม่มีข้อมูล
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
            {/* </div> */}
            <tr className=' d-flex justify-content-end'>
                {/* ข้อมูล ณ วันที่ {date191data.updateDate} */}
            </tr>

        </Container>
    );


}



